



















































































































import { Vue, Component, Emit, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import tournamentStore from '@/modules/tournament/tournament.store'
import { CreateTournamentTeamRequest } from '@/api/tournament'
import TeamDetailReview from '../TeamDetailReview'
import ServerError from '@/utils/server_error'
import i18n from '@/lang'
import { FileRecord } from 'vue-file-agent'
import { MemberEntity, MemberGameAccountEntity } from '@/api/member'
import userStore from '@/modules/auth/auth.store'

@Component({
  components: {
    TeamDetailReview
  }
})
export default class TeamRegistration extends Vue {
  tournamentModule = getModule(tournamentStore, this.$store)
  tournamentTeamForm: CreateTournamentTeamRequest = {
    name: '',
    logo: null,
    group: null
  }
  userModule = getModule(userStore, this.$store)
  nameRules: Function[] = [
    (v: any) => !!v || i18n.t('TeamRegistration.NameIsRequired'),
    (v: any) =>
      (v && v.length <= 32) ||
      i18n.t('TeamRegistration.NameCannotBeLongerThan32Characters')
  ]
  logoFile: FileRecord | null = null
  isFormValid: boolean = false
  loading: boolean = false
  isReviewing: boolean = false
  accepted: boolean = false

  @Prop({ default: '' }) readonly group!: string

  @Emit('tournamentTeamCreated')
  onTournamentTeamCreated(teamToken: string) {
    return teamToken
  }

  get isSoloTournament() {
    return this.tournament && this.tournament.capacityMaxPlayersPerTeam === 1
  }

  reset() {
    this.tournamentTeamForm = {
      name: '',
      logo: null,
      group: null
    }
    this.isFormValid = false
  }

  get tournament() {
    return this.tournamentModule.selectedTournament
  }

  async toReview() {
    this.isReviewing = true
  }

  async onSubmit() {
    this.loading = true

    // Override and use platform name as teamname for solo tournament
    if (this.isSoloTournament) {
      this.tournamentTeamForm = {
        name: this.userModule.member!.nickname,
        logo: null,
        group: this.group || null
      }
    }

    try {
      const teamToken = await this.tournamentModule.createTournamentTeam({
        tournamentTeam: {
          ...this.tournamentTeamForm,
          group: this.group || null
        },
        tournamentId: this.tournament!.tournamentId,
        logoFile: this.logoFile ? this.logoFile.file : null
      })
      this.onTournamentTeamCreated(teamToken as string)
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('TeamRegistration.SystemErrorMessage'))
        console.error(err)
      }
    } finally {
      this.loading = false
    }
  }
}
